import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { LabelWithControl } from "components/common/LabelControl";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { PO_SEARCH_OPPORTUNITIES_RESET } from "redux/actions/action-type";
import { showErrorMessageByCode } from "services/commonServices";

export const AddDialog = ({
  addDialog,
  onAddDialogClose,
  handleConfirmAddItem,
  searchOpportunitiesError,
  searchOpportunitiesData,
  onValidItemAdded,
  amendItems,
}) => {
  const [pinValue, setPinValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if(searchOpportunitiesData?.items) {
      if(searchOpportunitiesData.items[0].isDoNotOrderProduct) {
        setErrorMessage("Entered PIN is a Do Not Order Item");
      } else {
        onValidItemAdded(searchOpportunitiesData.items);
        handleCloseDialog();
      }
    }
  },[searchOpportunitiesData]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (searchOpportunitiesError?.response?.data?.httpResponseCode === 404) {
      setErrorMessage(searchOpportunitiesError.response.data.errorMessage);
    } else if (searchOpportunitiesError?.response) {
      const { errContent } = showErrorMessageByCode(searchOpportunitiesError);
      setErrorMessage(errContent);
    }
  }, [searchOpportunitiesError]);

  const handleInputChange = (event) => {
    const value = event.target.value.trim();
    const pinArray = value
      .split(",")
      .map((pin) => pin.trim())
      .filter((pin) => pin !== "");
    setPinValue(pinArray);

    if (pinArray.length > 1) {
      setErrorMessage("Only one PIN is allowed.");
      return;
    }

    if (!/^[0-9]{1,9}$/.test(pinArray[0])) {
      setErrorMessage("Only numbers (0-9) up to 9 digits are allowed.");
      return;
    }

    if (amendItems.some((item) => item.packId === Number(pinArray[0]))) {
      setErrorMessage("PIN already exists in PO");
      return;
    }

    setErrorMessage("");
  };

  const handleCloseDialog = () => {
    dispatch({ type: PO_SEARCH_OPPORTUNITIES_RESET });
    setPinValue("");
    setErrorMessage("");
    onAddDialogClose();
  };

  const handleConfirm = () => {
    if (amendItems.some((item) => item.packId === Number(pinValue))) {
      setErrorMessage("PIN already exists in PO");
      return;
    }
    handleConfirmAddItem(pinValue);
  };

  return (
    <Dialog open={addDialog} onClose={handleCloseDialog}>
      <div className="labelControl dialogStyling">
        <DialogTitle>Add Item</DialogTitle>
        <DialogContent>
          <LabelWithControl label="Enter a PIN" labelId="pin">
            <TextField
              labelid="pin"
              value={pinValue}
              onChange={handleInputChange}
              placeholder="Enter a single PIN"
              fullWidth
              aria-label="Enter a PIN"
              error={!!errorMessage}
              helperText={errorMessage}
            />
          </LabelWithControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseDialog}
            className="commonPOButtons"
            style={{ marginRight: "8px" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            className="commonPOButtons"
            disabled={!pinValue || errorMessage }
          >
            Confirm
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
